document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "undefined") {
    return;
  }

  /* HERO SLIDER */
  const hero = document.querySelector(".hero-swiper .swiper");

  if (hero) {
    new Swiper(hero, {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".hero-swiper .swiper-pagination",
        clickable: true,
      },
    });
  }

  /* GALLERY SLIDERS */
  document.querySelectorAll(".gallery-swiper").forEach(function (slider) {
    const thumbsEl = slider.querySelector(".gallery-thumbs");
    const mainEl = slider.querySelector(".gallery-top");

    if (!thumbsEl || !mainEl) {
      return;
    }

    const thumbs = new Swiper(thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 15,
      watchSlidesProgress: true,

      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },

      navigation: {
        nextEl: slider.querySelector(".thumbs-next"),
        prevEl: slider.querySelector(".thumbs-prev"),
      },
    });

    new Swiper(mainEl, {
      spaceBetween: 10,

      thumbs: {
        swiper: thumbs,
      },
    });
  });
});
